<micro-lookup domain="notif" obj="subscriptions" url="/notif/subscriptions" [key]="subscriptionId"></micro-lookup>
